import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { AppConfigService } from './app/auth/services/app-config.service';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((platformRef) => {
    // Obtiene el servicio de configuración inyectado
    const appConfig = platformRef.injector.get(AppConfigService);

    // Carga la configuración antes de continuar
    return appConfig.loadConfig().then(() => {
      if (appConfig.config.production) {
        enableProdMode();
      }
    });
  })
  .catch((err) => console.error(err));
